import React from 'react';
import Logo from '../Logo';
import SeletorDeIdioma from '../SeletorDeIdioma';
import { Link, useIdioma } from '../../i18n';
import '../../styles/NewHomeHeader.css';

/**
 * O cabeçalho da página nova, como na proposta: a marca no centro e dois links
 * de cada lado, dentro da folha de abertura. Não fica preso no alto: rola junto
 * com a página, e o Header compartilhado segue servindo as outras telas.
 *
 * "Como funciona" e "Perguntas" saem no telefone, onde só cabem Preços e Entrar.
 * O seletor de idioma fica numa linha própria acima: um terceiro item de um
 * lado só desfazia a simetria e espremia os links.
 */
const NewHomeHeader = () => {
  const { t } = useIdioma();

  return (
    <header className="nh nh-cabecalho">
      <div className="nh-cabecalho-idioma">
        <SeletorDeIdioma />
      </div>
      <nav className="nh-cabecalho-linha" aria-label={t('inicio.cabecalho.navegacao')}>
        <div className="nh-cabecalho-lado">
          <a className="is-largo" href="#como">{t('inicio.fecho.comoFunciona')}</a>
          <a href="#pricing">{t('site.precos')}</a>
        </div>
        <Link to="/" className="nh-cabecalho-marca" aria-label="Silent Puma">
          <Logo size={30} />
        </Link>
        <div className="nh-cabecalho-lado">
          <a className="is-largo" href="#perguntas">{t('inicio.fecho.perguntas')}</a>
          <Link to="/login">{t('site.entrar')}</Link>
        </div>
      </nav>
    </header>
  );
};

export default NewHomeHeader;
